import React, { Component } from 'react';

class AppLayout extends Component {
    render() {
        return (
            <div className="full-height">
                {this.props.children}
            </div>
        );
    }
}

export default AppLayout;